import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Info, ShieldCheck, ShoppingBag, LogIn, LayoutDashboard } from 'lucide-react';

const navItems = [
  { name: 'Home', path: '/', icon: <Home size={18} /> },
  { name: 'About', path: '/about', icon: <Info size={18} /> },
  // { name: 'Products', path: '/products', icon: <ShoppingBag size={18} /> },
  // { name: 'Services', path: '/services', icon: <ShieldCheck size={18} /> },
  // { name: 'Dashboard', path: '/dashboard', icon: <LayoutDashboard size={18} /> },
  // { name: 'Login', path: '/login', icon: <LogIn size={18} /> },
];

const Navbar = () => {
  const location = useLocation();

  return (
    <motion.nav
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className='sticky top-0 z-50 bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] shadow-lg border-b border-blue-900'
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between items-center h-25 p-3'>
          {/* Logo */}
          <Link to='https://therealpharmacy.com/' className='flex items-center gap-2'>
            <img src='real.png?v=1.1' alt='The Real Pharmacy' className=' w-auto h-20 ' />
          </Link>

          {/* Navigation Menu */}
          <div className='flex space-x-4'>
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`flex items-center gap-1 px-3 py-2 rounded-md text-sm font-medium transition-all duration-300 
                  ${
                    isActive
                      ? 'bg-blue-700 text-white shadow-sm'
                      : 'text-gray-300 hover:bg-blue-600 hover:text-white'
                  }
                  `}
                >
                  {item.icon}
                  <span>{item.name}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
